import React, { useState, useContext, useEffect, useRef } from 'react';
import { v4 as uuidv4 } from 'uuid';

import { Check } from 'react-feather';
import { FormTextInput } from '../../Components/FormTextInput';
import { useScreenTransition } from '../../Hooks/useScreenTransition';
import { useEnterKey } from '../../Hooks/useEnterKey';
import { AuthContext } from '../../Context/AuthContext';
import { NotificationContext } from '../../Context/NotificationContext';
import { DataContext } from '../../Context/DataContext';
import TopBar from '../../Components/TopBar';
import SecureAndPrivate from '../../NewComponents/SecureAndPrivate';
import NewButton from '../../NewComponents/NewButton';
import SignInForm from '../SignIn/SignInForm';
import CreateAccount from '../CreateAccount/CreateAccount';
import LogoAuthNavbar from '../../NewComponents/LogoAuthNavbar';
import CreateOrderNav from '../../NewComponents/CreateOrderNav';
import axios from 'axios';
import { ReactComponent as QUOTESUCCESS } from "../../assets/icons/quote-success.svg";
import PopUpModal from '../../NewComponents/PopUpModal';
import './QuoteContact.css';
import { auth, firestore, getFullHttpUrl } from '../../firebase.config';
import { getCounter } from '../../Data/Functions/getCounter';
import { EAST1 } from '../../utility/enums';
import { getExpeditedFeeOption } from '../../Data/Functions';
import { HowDidYouHearAboutUs } from '../../Data/Functions/HowDidYouHear';
import { updateHowDidYouHearData } from '../../Data/Functions/HowDidYouHear';

function sleep(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}

const emailRegex = new RegExp("^[a-zA-Z0-9._+%-]+@[a-zA-Z0-9-]+\\.[a-zA-Z]{2,}(\\.?[a-z]{2})?$");

const QuoteContact = ({ windowSize }) => {

  const { transitionTo } = useScreenTransition();
  const { showNotification } = useContext(NotificationContext);
  const { signedIn } = useContext(AuthContext);
  const { quote, setQuote, userData, teamData } = useContext(DataContext);

  const [email, setEmail] = useState('');
  const [submitButton, setSubmitButton] = useState('Complete');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isCreateAccountOpen, setIsCreateAccountOpen] = useState(false);
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [invalidEmail, setInvalidEmail] = useState(false);
  const [discountCode, setDiscountCode] = useState('');
  const [appliedCode, setAppliedCode] = useState('');
  const [discount, setDiscount] = useState(0);
  const [discountBtn, setDiscountBtn] = useState("Apply");
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [quotePlaced, setQuotePlaced] = useState(false);
  const [storeQuoteID, setStoreQuoteID] = useState(null);

  useEffect(() => {
    if (quotePlaced === true) {
      return;
    }
    if (!showSuccessModal && quote.parsed && ( !quote.languageFrom || quote.languageFrom === '' || !quote.languageTo || quote.languageTo === '' || !quote.files || quote.files.length === 0)) {
      transitionTo('/quote/details');
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [quote]);

    useEffect(() => {
      if(userData && userData.teamId && teamData){
        setDiscount(teamData.discount || 0);
      }
    }, [userData, teamData])

  const setDataByUser = () => {
    const first = userData.firstName ? userData.firstName : userData.name;
    const last = userData.lastName ? userData.lastName : "";
    localStorage.setItem('quote', JSON.stringify({ ...quote, files: JSON.stringify(quote.files?.filter(f => f.ref && f.url && f.status === 'complete').map(file => ({ id:file.id, name: file.name, ref: file.ref, url: file.url, type: 'source', size: file.file ? file.file.size : file.size, format: file.file ? file.file.type : file.format, status: 'complete', progress: 100, timestamp: file.timestamp }))), firstName: first, lastName: last, name: userData.name, email: userData.email.toLowerCase() }));
    setQuote(q => ({ ...q, firstName: first, lastName: last, name: userData.name, email: userData.email.toLowerCase() }));
    setEmail(userData.email.toLowerCase());
    setFirstName(first);
    setLastName(last);
  }

  const handleSaveNewAddress = async (address) => {
    
    const newAddress = { default: false, ...address };
    const mShipping = userData.teamId && teamData ? teamData.shipping ? teamData.shipping.concat([newAddress]) : [newAddress] 
      : userData.shipping ? userData.shipping.concat([newAddress]) : [newAddress];

    await firestore.collection(userData.teamId && teamData ? "teams" :"users")
    .doc(userData.teamId && teamData ? userData.id : userData.id)
      .update({
        shipping: mShipping
      })
      .then(() => {
      })
      .catch(error => {
        showNotification('Error', "An error ocurred while saving the address. Unfortunately, the address couldn't be saved.", 'error');
      })
  }


  useEffect(() => {
    if (signedIn && auth.currentUser && userData && !showSuccessModal) {
      setDataByUser();
    } else {
      sleep(600).then(() => {
        if (signedIn && auth.currentUser && userData && !showSuccessModal) {
          setDataByUser();
        }
      })
    }

    if (!signedIn && quote && !showSuccessModal) {
      setFirstName(quote.firstName || "");
      setLastName(quote.lastName || "");
      setEmail(quote.email || "");
      setDiscount(quote.discount || 0);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [signedIn, userData]);

  

  const handleSubmitQuote = async () => {
    setSubmitButton("Completing...");
    if (!emailRegex.test(email.toLowerCase())) {
      return setInvalidEmail(true);
    }

    const now = new Date();
    
    let quoteNumber = 0;

    await getCounter("quote").then((number) => {
      quoteNumber = parseInt(number, 10);
      })
    .catch((error) => { });

    if (quoteNumber === 0) {
      showNotification(
        "Error",
        "An error occurred while submitting the quote. Please, try again. If it persists, contact support.",
        "error"
      );
      return false;
    }

    const hardCopyAddress = quote.hardCopy && quote.hardCopyExtra;
    const saveNewAddress = hardCopyAddress && hardCopyAddress.newAddress && hardCopyAddress.saveAddress;

    const getAddress = () => {
      if (signedIn && userData && userData.teamId && teamData && teamData.shipping && teamData.shipping.length > 0 ) {
         return teamData.shipping.find((a) => a.id === hardCopyAddress.id);
        }else if (signedIn && userData && userData.shipping && userData.shipping.length > 0) {
          return userData.shipping.find((a) => a.id === hardCopyAddress.id);
        }
        return null;
      }
    const address = hardCopyAddress?.newAddress
      ? {
        id: hardCopyAddress.id,
        country: hardCopyAddress.country,
        addressName: hardCopyAddress.addressName,
        firstName: hardCopyAddress.firstName,
        lastName: hardCopyAddress.lastName,
        recipient: `${hardCopyAddress.firstName} ${hardCopyAddress.lastName}`,
        region: hardCopyAddress.region,
        city: hardCopyAddress.city,
        zipCode: hardCopyAddress.zipCode,
        street: hardCopyAddress.street,
        apartment: hardCopyAddress.apartment,
        newAddress: hardCopyAddress.newAddress
      }
      : getAddress();

    const saveNewAddressData = saveNewAddress ? address : "";

    // Generate a new document reference with an auto-generated ID
    const newQuoteID = uuidv4(); // Get the auto-generated ID
    const newQuoteRef = firestore.collection("quotes").doc(newQuoteID);

    const data = {
        quoteID: newQuoteID, 
        clientFirstName: quote.clientFirstName,
        clientLastName: quote.clientLastName,
        quoteNumber: quoteNumber,
        userID: signedIn ? auth.currentUser.uid : "",
        teamId: signedIn ? (userData.teamId ? userData.teamId : "") : "",
        email: signedIn
          ? userData
            ? userData.email
            : auth.currentUser.email
          : email.toLowerCase(),
        firstName: firstName,
        lastName: lastName,
        name: `${firstName} ${lastName}`,
        certified: quote.certified,
        languageFrom: quote.languageFrom,
        languageTo: quote.languageTo,
        notarization: quote.notarization,
        expedited: quote.expedited,
        expeditedPlus: quote.expeditedPlus,
        hardCopy: quote.hardCopy,
        hardCopyExtra: hardCopyAddress
          ? { ...address, method: hardCopyAddress.method, requireSignature: hardCopyAddress.requireSignature }
          : null,
        generalNotes: quote.generalNotes,
        notes: quote.generalNotes,

        files: quote.files.map((file) => ({
          id:file.id,
          name: file.name,
          ref: file.ref,
          url: file.url,
          type: file.type ?? "source",
          size: file.size,
          format: file.file ?? file.format,
          timestamp: now.getTime(),
        })),
        timestamp: now.getTime(),
        status: "in-review",
        discountApplied: discount > 0 ,
        discount: discount || 0,
        userNotes: "",
        expeditedServiceOption: getExpeditedFeeOption(userData, teamData),
        discountCode: appliedCode,
        howDidYouHear: {selectedOption, hasInput: showInputOption, inputText: optionInput}
      }

    
    newQuoteRef
      .set(data)
      .then(() => {
        if (signedIn && userData && saveNewAddress) {
          handleSaveNewAddress(saveNewAddressData);
        }
        setStoreQuoteID(newQuoteID); // Store the newly created quote ID
        setShowSuccessModal(true);
        setQuotePlaced(true);

        updateHowDidYouHearData(newQuoteID, {selectedOption, hasInput: showInputOption, inputText: optionInput}, quote.email, quote.name, "", "", quoteNumber);

        localStorage.setItem("quote", JSON.stringify({ name: "", email: "", parsed: true }));
        setQuote({ name: "", email: "", parsed: true });

        if (appliedCode !== "") {
          axios.post(getFullHttpUrl("updateCouponUsage", EAST1), {
            code: appliedCode,
          }).catch(() => { });
        }
        setSubmitButton("Complete");
        
      })
      .catch((error) => {
        setSubmitButton("Complete");
        showNotification("Error", "An error occurred while submitting the quote. Please, try again.", "error");
      });
  };

  const triggerEnter = () => {
    if (!(firstName === "" || email === "" || submitButton === "completing...")) {
      handleSubmitQuote();
    }
  }

  useEnterKey(() => triggerEnter());

  const handleEmailChange = (value) => {
    setEmail(value);
    setInvalidEmail(false);
  }

  const handleLoginOpen = (newState) => {
    setIsModalOpen(newState);
  }

  const handleCreateAccountOpen = (newState) => {
    setIsCreateAccountOpen(newState);
  }

  const handleApplyCode = () => {
    setDiscountBtn("Applying...");
    // setApplingDiscount(true);
    
    try {
      firestore.collection('coupons').where('code', '==', discountCode).get()
        .then((querySnapshot) => {
          if (querySnapshot.docs.length > 0) {
            const doc = querySnapshot.docs[0];

            if (doc.data().uses > 0) {
              setDiscount(doc.data().discount);
              setAppliedCode(discountCode);
            } else {
              showNotification('Error', "That code is no longer valid. Please, try another one.", 'error');
            }
          } else {
            showNotification('Error', "That code doesn't exist. Please, try another one.", 'error');
          }
        })
    }
    catch (e) {
      showNotification('Error', "There was an error applying the code. Please, try again.", 'error');
    }
    finally {
      setTimeout(() => {
        setDiscountBtn("Apply");
      }, 500);
    }
  }

  const handlePopUpClick = (e) => {
    if (storeQuoteID) {
      transitionTo(`/account/quote/${storeQuoteID}`, e);
      return setShowSuccessModal("");
    } else {
      transitionTo("/", e);
      return setShowSuccessModal("");

    }
  }

  const [showHowDidYouHear, setShowHowDidYouHear] = useState(false);
  const [selectedOption, setSelectedOption] = useState("");
  const [showInputOption, setShowInputOption] = useState(false);
  const [optionInput, setOptionInput] = useState("");

  const inputRef = useRef(null);

  const checkHowDidYouHearInDB = async () => {
    firestore.collection("howDidTheyHear").where("email", "==", email).get().then((qSnap) => {
      if(qSnap.empty){
        return;
      }
      const doc = qSnap.docs[0];
      if(doc.exists){
        const {selectedOption, hasInput, inputText} = doc.data().howDidYouHear;
        setSelectedOption(selectedOption);
        setOptionInput(inputText);
        setShowInputOption(hasInput);
      }
    });

  }

  useEffect(() => {
    const howDidYourHearAnswered = JSON.parse(localStorage.getItem("howDidYouHear"));
    setShowHowDidYouHear(!howDidYourHearAnswered || (howDidYourHearAnswered && !howDidYourHearAnswered.selectedOption));

    if(quote.howDidYouHear){
      const {selectedOption, hasInput, inputText} = quote.howDidYouHear;
      setSelectedOption(selectedOption);
      setOptionInput(inputText);
      setShowInputOption(hasInput);
    }else{
      checkHowDidYouHearInDB();
    }
  }, [quote, email])


  const onClickOption = (option) => {
    setSelectedOption(option.value);
    setShowInputOption(option.extraInput??false);
    setOptionInput("");
    inputRef.current && inputRef.current.focus();
  }

  const checkHearOption = () => {
    if(!showHowDidYouHear){
      return false;
    }
    return (!signedIn && !userData) ? selectedOption === "" ? true : showInputOption ? !optionInput : false : false;
  }

  return (
    <>
      <TopBar />

      <SignInForm open={isModalOpen} isLoginFormOpen={handleLoginOpen} isCreateAccountOpen={handleCreateAccountOpen} pageRedirect={false} />
      <CreateAccount open={isCreateAccountOpen} isCreateAccountOpen={handleCreateAccountOpen} isLoginFormOpen={handleLoginOpen} />

      {showSuccessModal && <PopUpModal title="Quote Created" btnText="Go to Quote" onClick={(e) => handlePopUpClick(e)}
        text="You can track its status on the quote page in your account. We'll send
            you an email notification as soon as the cost is calculated.">
        <QUOTESUCCESS />
      </PopUpModal>}

      <div className="mainOrderContainer">
        <div className="mainOrderHeader">
          <LogoAuthNavbar isAuth={signedIn} showButtons={false} />
        </div>
        <div className="mainOrderPageContainer">
          <div className="mainOrderPageContainerOptions">
            <CreateOrderNav title="3. Your Contact" stage={3} stages={3} />
            <div></div>
          </div>
        </div>
        <div className="mainOrderPageContainer">
          <div className="mainOrderPageContainerOptions">

            <div id="mainPrimary" className="mainOrderPrimaryContent">
              <div className="quotePrimaryOptionsWrapper">
                <h4 className="quotePrimaryTitle">Your Contact</h4>
                <div className='orderInputWrapper'>
                  <div className="quoteDetailsInputsContainer">
                    <FormTextInput disabled={signedIn} placeholder="First Name" value={firstName} onChange={setFirstName} onKeyDown={(e) => e.key === "Enter" && triggerEnter()} />
                    <FormTextInput disabled={signedIn} placeholder="Last Name" value={lastName} onChange={setLastName} onKeyDown={(e) => e.key === "Enter" && triggerEnter()} />
                  </div>
                  <FormTextInput incorrect={invalidEmail} clearInputIcon={true} disabled={signedIn} placeholder="Email" value={email} onChange={handleEmailChange} onKeyDown={(e) => e.key === "Enter" && triggerEnter()} />
                  {!signedIn && <div className='orderLinkContainer'>
                    <div className='orderSimpleTextLink' onClick={() => setIsCreateAccountOpen(true)}>Create an Account</div>
                    <div className='orderSimpleText'>If you have an account <span className='link' onClick={() => setIsModalOpen(true)}>Sign in</span></div>
                  </div>}
                  {!signedIn && <p className="quoteExtraMessage">Creating an account allows you to access your quote and order history, saved addresses, payment methods, and site preferences anytime.</p>}
                </div>

              </div>

              <div className="quotePrimaryOptionsWrapper">
                <h4 className="quotePrimaryTitle">Discount Code</h4>
                <div className="orderDiscountCodeWrapper">
                  <FormTextInput placeholder={"Discount code"} value={discountCode} onChange={setDiscountCode} discountIcon={discount > 0} discountIconText={`${discount}%`} />
                  <NewButton text={discountBtn} disabled={discountBtn === "Applying..."} back={true} icon={false} onClick={() => handleApplyCode()} whiteBtn={true} />
                </div>
              </div>

              {showHowDidYouHear && !signedIn && !userData &&
              <div className="quotePrimaryOptionsWrapper">
                <h4 className="quotePrimaryTitle">How did you hear about us?</h4>
                <div className='flex flex-wrap gap-[8px] mt-4'>
                  {HowDidYouHearAboutUs.map((option, i) => 
                     <div key={option.value} className={`relative flex justify-start items-center gap-2 min-w-[200px] overflow-hidden transition-all duration-300
                      bg-[#fff] rounded-[8px] ${showInputOption && selectedOption === option.value  ? "px-[16px] pt-[16px] pb-[8px]" : "px-[16px] py-[16px]"} cursor-pointer hover:border-[#12ABBF]  min-h-[54px]
                      ${selectedOption === option.value ? 'border-[#12ABBF] border-[2px] ' : 'border-[#E6E7E9] border-[1px]'} "w-max" max-sm:w-full`} onClick={() => onClickOption(option)}>
                         {option.icon && <img src={option.icon} alt={""} className='w-[24px] h-[24px]'/> }
                         <p className={`${showInputOption && selectedOption === option.value ? `transition-all duration-300 absolute text-[#686f7b] ${selectedOption === option.value ? "text-[12px] weight-[400] top-[4px] left-[8px]" : "top-[18px] left-[16px] onBoarding-description"}` : "onBoarding-description"}`}>
                          {option.label}
                          </p> 
                          {showInputOption && selectedOption === option.value && 
                          <input ref={inputRef} type="text" autoFocus className={`${i === 4 ? "w-[218px]": i === 5 ? "w-[287px]" : "w-full"} min-w-[160px] h-[18px] border-[0] outline-none bg-transparent text-[14px] weight-[400]`} placeholder={option.extraInputLabel?? "Please specify"} value={optionInput} onChange={(e) => setOptionInput(e.target.value)} onClick={(e) => e.stopPropagation()}/>
                        }
                    </div>
                  )}
                </div>
              </div>
              }

              <div>
                <div className="quoteSubmitButtonContainer">
                  <NewButton text="Back to Options" onClick={(e) => transitionTo('/quote/options', e)} back={true} />
                  <NewButton text={submitButton} disabled={(firstName === "" || email === "" || submitButton === "completing...")} onClick={() => handleSubmitQuote()} />
                </div>
              </div>
            </div>
          </div>

          <div className='mainOrderSecondaryContent'>
            <div className='mainOrderSecondaryContentWrap'>
              <div className="orderSummary">
                <h3 className="quotePrimaryTitle">WHAT TO EXPECT</h3>
                <div className="quoteSecondarySub">
                  We’ll respond quickly with a formal quote covering the cost and
                  turnaround time for your translation project.
                </div>
                <div className="quoteSecondaryLine">
                  <Check size={15} className="quoteSecondaryLineIcon" />
                  <div className="quoteSecondaryLineText">
                    Free quote, no obligation to buy
                  </div>
                </div>
                <div className="quoteSecondaryLine">
                  <Check size={15} className="quoteSecondaryLineIcon" />
                  <div className="quoteSecondaryLineText">
                    Final pricing with no surprises
                  </div>
                </div>
                <div className="quoteSecondaryLine">
                  <Check size={15} className="quoteSecondaryLineIcon" />
                  <div className="quoteSecondaryLineText">
                    Estimated turnaround time
                  </div>
                </div>
                <div className="quoteSecondaryLine">
                  <Check size={15} className="quoteSecondaryLineIcon" />
                  <div className="quoteSecondaryLineText">
                    Quick convert to order when ready
                  </div>
                </div>
                <div className="quoteSecondaryLine">
                  <Check size={15} className="quoteSecondaryLineIcon" />
                  <div className="quoteSecondaryLineText">
                    Quote is guaranteed for 30 days
                  </div>
                </div>
              </div>

              <div>
                <SecureAndPrivate />

              </div>
            </div>
          </div>
        </div>

      </div>
    </>
  );
}

export default QuoteContact;